import React from 'react'
// Live Services
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { LiveChartSetConfigs, UnifiedKpiEvent, UnifiedKpiFlowMessage } from './types/types'
import { FinosDynamicChartSetReducer } from './FinosDynamicChartSetReducer'
import { withSuspenseWrapper } from './SuspenseWrapper'

const WrapperFinosDynamicChartSet = withSuspenseWrapper(React.lazy(() => import('./FinosDynamicChartSet')))

const DEFAULT_DYNAMIC_CHART_SET_CONFIG: LiveChartSetConfigs = {
    finosConfig: {
        version: '3.7.1',
        plugin: 'Datagrid',
        plugin_config: {
            columns: {},
            editable: false,
            scroll_lock: false
        },
        columns_config: {},
        settings: true,
        theme: 'Pro Light',
        title: null,
        group_by: [],
        split_by: [],
        columns: [],
        filter: [],
        sort: [],
        expressions: {},
        aggregates: {}
    }
}

widgetService.register({
    type: 'dynamic-chart-set',
    name: 'Dynamic Chart Set',
    description: 'Multiple chart in one',
    config: DEFAULT_DYNAMIC_CHART_SET_CONFIG,
    impl: reactWidgetWrapper<UnifiedKpiEvent, UnifiedKpiFlowMessage, LiveChartSetConfigs>(
        WrapperFinosDynamicChartSet,
        FinosDynamicChartSetReducer
    )
})
